import React from 'react';
import { Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Product',
      colSpan: 'col-span-1 md:col-span-2',
      links: [
        { label: 'Why It Works', href: '#why-it-works' },
        { label: 'How It Works', href: '#how-it-works' },
        { label: 'Plans', href: '#plans' },
        { label: 'FAQ', href: '#faq' },
      ],
    },
    {
      title: 'For Families',
      colSpan: 'col-span-1 md:col-span-3',
      links: [
        { label: 'For Parents', href: '#for-families' },
        { label: 'For Language Schools', href: '#for-families' },
        { label: 'Download App', href: '#download' },
      ],
    },
    {
      title: 'Company',
      colSpan: 'col-span-1 md:col-span-3',
      links: [
        { label: 'Privacy Policy', href: '/privacy-policy' },
        { label: 'Terms and Conditions', href: '/terms-and-conditions' },
        { label: 'Delete Account', href: '/delete-account' },
      ],
    },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to internal routes
      window.location.href = href;
    }
  };

  return (
    <footer className="bg-[#333333] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 justify-between">
          {/* Brand column */}
          <div className="space-y-6 lg:w-[30%] lg:pr-8">
            <h3 className="text-3xl font-bold text-[#FF7F30]">LinguPix</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              LinguPix helps children ages 3–7 learn through picture associations, swipe-based repetition, and playful daily progress.
            </p>
            {/* Hidden Store Badges - kept for future use */}
            <div className="hidden flex-col space-y-3">
              <a 
                href="#" 
                className="transition-transform lg:hover:scale-105 duration-200 block"
                style={{ transformOrigin: 'center center' }}
                aria-label="Download on the App Store"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_a0c8a310-9195-420d-8ad2-c73f20567f76/artifacts/e04qpahv_app-store-white.png" 
                  alt="Download on the App Store" 
                  className="h-[44px] w-auto"
                />
              </a>
              <a 
                href="#" 
                className="transition-transform lg:hover:scale-105 duration-200 block"
                style={{ transformOrigin: 'center center' }}
                aria-label="Get it on Google Play"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_a0c8a310-9195-420d-8ad2-c73f20567f76/artifacts/jepnukno_play-store-white.png" 
                  alt="Get it on Google Play" 
                  className="h-[44px] w-auto"
                />
              </a>
            </div>
          </div>

          {/* Links and Contact side */}
          <div className="grid grid-cols-2 md:grid-cols-12 gap-8 lg:w-[70%] text-sm sm:text-base">

          {/* Links columns */}
          {footerLinks.map((column, index) => (
            <div key={index} className={`space-y-6 ${column.colSpan}`}>
              <h4 className="text-lg font-semibold text-white">{column.title}</h4>
              <ul className="space-y-3">
                {column.links.map((link, idx) => (
                  <li key={idx}>
                    <a
                      href={link.href}
                      onClick={(e) => scrollToSection(e, link.href)}
                      className="text-gray-400 hover:text-[#FF7F30] transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact column */}
          <div className="space-y-6 col-span-2 md:col-span-4">
            <h4 className="text-lg font-semibold text-white">Contact</h4>
            <div className="space-y-2">
              <a
                href="mailto:contact@lingu-pix.app"
                className="flex items-start sm:items-center text-gray-400 hover:text-[#FF7F30] transition-colors group break-words"
              >
                <Mail size={20} className="mr-2 mt-0.5 sm:mt-0 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <span>contact@lingu-pix.app</span>
              </a>
              <p className="text-gray-400 text-sm leading-relaxed">
                Questions? We’d love to hear from you and help.
              </p>
            </div>
          </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center space-y-4 md:space-y-0">
          <p className="text-gray-400 text-sm text-left">
            © {currentYear} LinguPix. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm text-left md:text-right">
            Made with care for young learners and the adults guiding them.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;